import { Tab, Tabs } from '@nextui-org/react';
import { useTranslation } from '../../../../common/src/hooks/useTranslation';
import { CostStandard } from '../../hooks/useExporterCostView';

interface CostStandardToggleProps {
  value: CostStandard;
  onChange: (value: CostStandard) => void;
}

/** Switches cost figures between the FM standard and the exporter's own. */
const CostStandardToggle = ({ value, onChange }: CostStandardToggleProps) => {
  const { t } = useTranslation('settlements');
  return (
    <Tabs
      size='sm'
      aria-label={t('Estándar de costos')}
      selectedKey={value}
      onSelectionChange={(key) => onChange(String(key) as CostStandard)}
    >
      <Tab key='fm' title={t('Costos Estándar FruitMarkets')} />
      <Tab key='exporter' title={t('Estándar Exportadora')} />
    </Tabs>
  );
};

export default CostStandardToggle;
